<template>
<!--  <content-layout>-->
<!--    <div class="sale-office">-->
<!--      <a-alert-->
<!--        banner-->
<!--        show-icon-->
<!--        type="warning"-->
<!--        message="系统监测：账号正在使用其他设备登陆，请谨慎处理。"-->
<!--      />-->

<!--      <a-row :gutter="14" class="main-grid">-->
<!--        <a-col :span="16">-->
<!--          &lt;!&ndash;客户数据&ndash;&gt;-->
<!--          <div class="block1">-->
<!--            <div class="section-header">-->
<!--              <div class="section-title">-->
<!--                <span class="title-marker"></span>-->
<!--                客户数据-->
<!--              </div>-->
<!--              <div class="header-actions">-->
<!--                <a-radio-group size="small" :value="customerRange">-->
<!--                  <a-radio-button value="日">日</a-radio-button>-->
<!--                  <a-radio-button value="周">周</a-radio-button>-->
<!--                  <a-radio-button value="月">月</a-radio-button>-->
<!--                  <a-radio-button value="年">年</a-radio-button>-->
<!--                </a-radio-group>-->
<!--                <a-select size="small" :value="customerMonth" class="filter-select">-->
<!--                  <a-select-option value="2024-08">2024-08</a-select-option>-->
<!--                </a-select>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="customer-body">-->
<!--              <div class="customer-left">-->
<!--                <div class="metric-groups">-->
<!--                  <div class="metric-group" v-for="group in customerGroups" :key="group.label">-->
<!--                    <div class="metric-total">-->
<!--                      <div class="metric-number">{{ group.total }}</div>-->
<!--                      <div class="metric-label">{{ group.label }}</div>-->
<!--                    </div>-->
<!--                    <div class="metric-items">-->
<!--                      <div class="metric-item" v-for="item in group.items" :key="item.label">-->
<!--                        <div class="metric-item-label">{{ item.label }}</div>-->
<!--                        <div class="metric-item-value">{{ item.value }}</div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="customer-right">-->
<!--                <div class="panel-title">新增客户占比</div>-->
<!--                <div ref="customerPie" class="pie-chart"></div>-->
<!--                <a-select size="small" :value="pieSelect" class="pie-select">-->
<!--                  <a-select-option value="新增客户">新增客户</a-select-option>-->
<!--                </a-select>-->
<!--                &lt;!&ndash; <div class="panel-list">-->
<!--                  <div class="panel-item" v-for="item in pieList" :key="item.label">-->
<!--                    <span class="dot" :style="{ background: item.color }"></span>-->
<!--                    <span class="panel-item-label">{{ item.label }}</span>-->
<!--                    <span class="panel-item-value">{{ item.value }}%</span>-->
<!--                  </div>-->
<!--                </div> &ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash; ai块 &ndash;&gt;-->
<!--          <div class="ai-content">-->
<!--            <div class="tip-icon">AI</div>-->
<!--            <div class="tip-content ai-text">-->
<!--              <div><span class="bluetext">客户层：</span> 获客指标全面下滑，稳定获客需多渠道协作。</div>-->
<!--              <div><span class="bluetext">销售层：</span>成交转化效率需提升，重点关注高意向客户。</div>-->
<!--              <div><span class="bluetext">转化层：</span>触达率提升空间较大，建议优化跟进节奏。</div>-->
<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash;房源去化与销售数据&ndash;&gt;-->
<!--          <a-row :gutter="14">-->
<!--            <a-col :span="8">-->
<!--              <a-card :bodyStyle="{height:'300px'}" class="panel-card" :bordered="false">-->
<!--                <div class="section-title">-->
<!--                  <span class="title-marker"></span>-->
<!--                  房源去化-->
<!--                </div>-->

<!--                <div>-->
<!--                  <div class="progress-row">-->
<!--                    <div class="progress-label">去化率</div>-->
<!--                    <div class="progress-value">50%</div>-->
<!--                  </div>-->
<!--                  <a-progress :percent="50" :show-info="false"/>-->
<!--                </div>-->

<!--                <div class="deplete-stats">-->
<!--                  <div class="deplete-main">-->
<!--                    <div>-->
<!--                      <div class="deplete-number">1000</div>-->
<!--                      <div class="deplete-label">合计房源数</div>-->
<!--                    </div>-->
<!--                    <div class="deplete-sub">25万平米</div>-->
<!--                    <div class="deplete-sub">40000.00万元</div>-->
<!--                  </div>-->
<!--                  <div class="deplete-split">-->
<!--                    <div class="split-item">-->
<!--                      <div class="split-number">500</div>-->
<!--                      <div class="split-sub">未售房源（套）</div>-->
<!--                      <div class="split-sub">12.5万平米</div>-->
<!--                      <div class="split-sub">8000.00万元</div>-->
<!--                    </div>-->
<!--                    <div class="split-item">-->
<!--                      <div class="split-number">500</div>-->
<!--                      <div class="split-sub">已售面积</div>-->
<!--                      <div class="split-sub">12.5万平米</div>-->
<!--                      <div class="split-sub">8000.00万元</div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </a-card>-->
<!--            </a-col>-->
<!--            <a-col :span="16">-->
<!--              <a-card class="panel-card" :bodyStyle="{height:'300px'}" :bordered="false">-->
<!--                <div class="section-header">-->
<!--                  <div class="section-title">-->
<!--                    <span class="title-marker"></span>-->
<!--                    销售数据-->
<!--                  </div>-->
<!--                  <a-select size="small" :value="saleMonth" class="filter-select">-->
<!--                    <a-select-option value="2024-08">2024-08</a-select-option>-->
<!--                  </a-select>-->
<!--                </div>-->


<!--                <div class="sale-summary">-->
<!--                  <div class="sale-item" v-for="item in saleSummary" :key="item.label">-->
<!--                    <div class="summary-box">-->
<!--                      <div class="summary-number">{{ item.label }}</div>-->
<!--                      <div class="summary-label">{{ item.value }}</div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="sale-summary">-->
<!--                  <div class="sale-item" v-for="item in saleDetail" :key="item.label">-->
<!--                    <div class="summary-box">-->
<!--                      <div class="summary-number">{{ item.label }}</div>-->
<!--                      <div class="summary-label">{{ item.value }}</div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="sale-summary">-->
<!--                  <div class="sale-item" v-for="item in sale3" :key="item.label">-->
<!--                    <div class="summary-box">-->
<!--                      <div class="summary-number">{{ item.label }}</div>-->
<!--                      <div class="summary-label">{{ item.value }}</div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--              </a-card>-->
<!--            </a-col>-->
<!--          </a-row>-->
<!--        </a-col>-->

<!--        <a-col :span="8">-->
<!--          <div class="summary-card">-->
<!--            <div class="summary-item">-->
<!--              <div class="summary-title">10条</div>-->
<!--              <div class="summary-text">待处理线索</div>-->
<!--            </div>-->
<!--            <div class="summary-item">-->
<!--              <div class="summary-title">1个</div>-->
<!--              <div class="summary-text">团队待处理</div>-->
<!--            </div>-->
<!--            <div class="warin">-->
<!--              <a-icon type="info-circle"/>-->
<!--              <span>未处理信息无法统计到数据</span>-->
<!--            </div>-->
<!--          </div>-->

<!--          <a-tabs type="card" :active-key="statTab" @change="statTab = $event" class="stat-tabs">-->
<!--            <a-tab-pane key="sale" :tab="'销售统计'">-->
<!--              <sale-stat-tab/>-->
<!--            </a-tab-pane>-->
<!--            <a-tab-pane key="customer" :tab="'客户统计'">-->
<!--              <customer-stat-tab/>-->
<!--            </a-tab-pane>-->
<!--            <a-tab-pane key="house" :tab="'房源统计'">-->
<!--              <house-stat-tab/>-->
<!--            </a-tab-pane>-->
<!--            <a-tab-pane key="intent" :tab="'意向统计'">-->
<!--              <intent-stat-->
<!--                :x-axis="intentLineXAxis"-->
<!--                :series="intentLineSeries"-->
<!--                :analysis-total="intentAnalysis.total"-->
<!--                :analysis-list="intentAnalysis.list"-->
<!--              />-->
<!--            </a-tab-pane>-->
<!--            <a-tab-pane key="team" :tab="'团队分析'">-->
<!--              <team-analysis-tab/>-->
<!--            </a-tab-pane>-->
<!--            <a-tab-pane key="analysis" :tab="'客户分析'">-->
<!--              <customer-analysis-->
<!--                :total="customerAnalysisTotal"-->
<!--                :dimension="customerAnalysisDimension"-->
<!--                :key-levels="keyCustomerLevels"-->
<!--                :key-pie-data="keyCustomerPieData"-->
<!--                :consultants="keyCustomerConsultants"-->
<!--                :gender-list="customerGenderList"-->
<!--              />-->
<!--            </a-tab-pane>-->
<!--          </a-tabs>-->
<!--        </a-col>-->
<!--      </a-row>-->
<!--    </div>-->
<!--  </content-layout>-->
</template>

<script>
import ContentLayout from '@/layouts/ContentLayout'
import * as echarts from 'echarts'
import SaleStatTab from '@/views/Dashboard/components/SaleStatTab.vue'
import CustomerStatTab from '@/views/Dashboard/components/CustomerStatTab.vue'
import HouseStatTab from '@/views/Dashboard/components/HouseStatTab.vue'
import TeamAnalysisTab from '@/views/Dashboard/components/TeamAnalysisTab.vue'
import IntentStat from '@/views/Dashboard/components/IntentStat.vue'
import CustomerAnalysis from '@/views/Dashboard/components/CustomerAnalysis.vue'

export default {
  name: 'SaleOffice',
  components: {
    ContentLayout,
    SaleStatTab,
    CustomerStatTab,
    HouseStatTab,
    TeamAnalysisTab,
    IntentStat,
    CustomerAnalysis
  },
  data() {
    return {
      pieSelect: '新增客户',
      customerRange: '月',
      customerMonth: '2024-08',
      saleMonth: '2024-08',
      statTab: 'sale',
      customerAnalysisDimension: 'all',
      pieChart: null,
      resizeHandler: null,
      customerGroups: [
        {
          total: '10组',
          label: '新增客户',
          items: [
            { label: '自然来访', value: '5组' },
            { label: '个人拓客', value: '5组' },
            { label: '小程序拓客', value: '5组' },
            { label: '来电', value: '5组' }
          ]
        },
        {
          total: '20组',
          label: '到访客户',
          items: [
            { label: '自然来访', value: '10组' },
            { label: '转访', value: '10组' },
            { label: '复访', value: '10组' },
            { label: '渠道转访', value: '5组' }
          ]
        },
        {
          total: '150组',
          label: '回访客户',
          items: [
            { label: '私电电话', value: '156组' },
            { label: '私盘微信', value: '156组' },
            { label: '商客池客户', value: '156组' }
          ]
        }
      ],
      pieList: [
        { label: '自然来访', value: 37, color: '#5B8FF9' },
        { label: '个人拓客', value: 49, color: '#5AD8A6' },
        { label: '小程序拓客', value: 13, color: '#F6BD16' }
      ],
      saleSummary: [
        { label: '销售额', value: '8套/1223.68万' },
        { label: '认购', value: '8套/1223.68万' },
        { label: '退房', value: '8套/1223.68万' }
      ],
      saleDetail: [
        { label: '项目回款', value: '8套/1223.68万' },
        { label: '房款回款', value: '8套/1223.68万' },
        { label: '车位回款', value: '8套/1223.68万' },
        { label: '地下室回款', value: '8套/1223.68万' },
        { label: '银行放款', value: '8套/1223.68万' }
      ],
      sale3: [
        { label: '累计项目欠款', value: '8套/1160.15万' },
        { label: '累计房款欠款', value: '6套/1223.68万' },
        { label: '累计银行待放款', value: '8套/1223.68万' },
        { label: '累计地下室欠款', value: '8套/1223.68万' },
        { label: '累计车位欠款', value: '8套/1223.68万' }
      ],
      intentLineXAxis: ['1栋', '2栋', '3栋', '20栋', '22栋', '23栋'],
      intentLineSeries: [
        { name: '总意向', data: [420, 400, 380, 310, 390, 450], color: '#ff6b6b' },
        { name: '第一意向', data: [320, 260, 210, 120, 190, 240], color: '#4c9bfd' },
        { name: '第二意向', data: [280, 230, 190, 140, 220, 260], color: '#f5a623' },
        { name: '第三意向', data: [260, 210, 170, 120, 200, 230], color: '#2bb55d' }
      ],
      intentAnalysis: {
        total: '100套',
        list: [
          { label: '第1意向', count: 200, percent: '200%', color: '#4c9bfd' },
          { label: '第2意向', count: 100, percent: '100%', color: '#f5a623' },
          { label: '第3意向', count: 90, percent: '90%', color: '#2bb55d' }
        ]
      },
      customerAnalysisTotal: '4000组',
      keyCustomerLevels: [
        { label: '高意向客户', sub: '3天内到访3次' },
        { label: '中意向客户', sub: '7天内到访2次' },
        { label: '低意向客户', sub: '到访1次' },
        { label: '潜在客户', sub: '未到访' }
      ],
      keyCustomerPieData: [
        { label: '高意向客户', value: 120, color: '#2b6de5' },
        { label: '中意向客户', value: 90, color: '#5ad8a6' },
        { label: '低意向客户', value: 60, color: '#f5a623' },
        { label: '潜在客户', value: 40, color: '#bfc9d4' }
      ],
      keyCustomerConsultants: [
        { name: '置业顾问姓名', value: '10人' },
        { name: '置业顾问姓名', value: '10人' },
        { name: '置业顾问姓名', value: '10人' }
      ],
      customerGenderList: [
        { label: '未知', count: '90组', percent: '90%', color: '#bfc9d4' },
        { label: '男', count: '5组', percent: '5%', color: '#2b6de5' },
        { label: '女', count: '5组', percent: '5%', color: '#ff5ac6' }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initPieChart()
      this.resizeHandler = () => {
        if (this.pieChart) {
          this.pieChart.resize()
        }
      }
      window.addEventListener('resize', this.resizeHandler)
    })
  },
  beforeDestroy() {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler)
    }
    if (this.pieChart) {
      this.pieChart.dispose()
      this.pieChart = null
    }
  },
  methods: {
    renderTabLabel(icon, label) {
      return this.$createElement('div', { class: 'stat-tab' }, [
        this.$createElement('a-icon', { props: { type: icon } }),
        this.$createElement('span', { class: 'stat-tab-label' }, label)
      ])
    },
    initPieChart() {
      if (!this.$refs.customerPie) {
        return
      }
      if (this.pieChart) {
        this.pieChart.dispose()
      }
      this.pieChart = echarts.init(this.$refs.customerPie)
      this.pieChart.setOption({
        tooltip: { trigger: 'item' },
        legend: { show: false },
        series: [
          {
            type: 'pie',
            radius: ['45%', '70%'],
            center: ['50%', '50%'],
            label: {
              show: true,
              formatter: '{b} {d}%',
              fontSize: 12
            },
            labelLine: {
              show: true,
              length: 12,
              length2: 10
            },
            data: this.pieList.map(item => ({
              name: item.label,
              value: item.value,
              itemStyle: { color: item.color }
            }))
          }
        ]
      })
    }
  }
}
</script>

<style lang="less" scoped>
.sale-office {
  display: flex;
  flex-direction: column;
}

.main-grid {
  margin-top: 14px;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #1f2f3d;
}


.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.title-marker {
  width: 4px;
  height: 14px;
  border-radius: 2px;
  background: #3e82f7;
  margin-right: 8px;
}

.metric-groups {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  gap: 12px;
}

.metric-group {
  display: flex;
  gap: 12px;
  align-items: center;
}

.metric-total {
  width: 90px;
}

.metric-number {
  font-size: 22px;
  font-weight: 700;
  color: #2b6de5;
}

.metric-label {
  color: #7a8699;
}

.metric-items {
  display: grid;
  //grid-template-columns:100px 100px 100px 100px;
  grid-template-columns: repeat(4, 1fr);
  gap: 50px;
  flex: 1;
}

.metric-item {
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fafcff;
}

.metric-item-label {
  color: #5b6b7c;
  font-size: 12px;
}

.metric-item-value {
  color: #2b6de5;
  font-weight: 600;
}

.customer-body {
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
}

.customer-left {
  flex: 1;
}

.customer-right {
  width: 300px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}

.panel-card {
  border-radius: 10px;
}

.panel-title {
  font-weight: 600;
  color: #1f2f3d;
}

.pie-chart {
  width: 180px;
  height: 180px;
}

.tip-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #e6f0ff;
  color: #2b6de5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
}

.tip-content {
  margin-left: 20px;
  font-size: 12px;
  color: #4d5b6a;
  display: flex;
  flex-direction: column;
}

.bluetext {
  font-weight: bold;
  color: #2b6de5;

}

.progress-row {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.progress-label {
  color: #7a8699;
}

.progress-value {
  color: #2b6de5;
  font-weight: 600;
}

.deplete-stats {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.deplete-main {
  margin-top: 10px;
  border-radius: 10px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.deplete-number {
  font-size: 18px;
  font-weight: 700;
}

.deplete-label {
  color: #7a8699;

}

.deplete-sub {
  font-size: 12px;
  color: #9aa5b1;
}

.deplete-split {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.split-item {
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  padding: 10px;
}

.split-number {
  font-weight: 700;
}

.split-label {
  color: #7a8699;
  margin-bottom: 2px;
}

.split-sub {
  font-size: 12px;
  color: #9aa5b1;
  margin-top: 5px;
}

.sale-summary {
  margin-bottom: 12px;
  display: grid;
  grid-template-columns: repeat(5, 1fr); // 固定5列
  gap: 16px;

  .sale-item {

  }
}

.summary-box {
  background: #f7f9fc;
  border-radius: 10px;
  padding: 10px;
}

.summary-number {
  color: #2b6de5;
  font-weight: 700;
}

.summary-label {
  font-size: 12px;
  color: #7a8699;
}

.summary-card {
  position: relative;
  border-radius: 12px;
  display: flex;
  gap: 12px;
  background: #f7fbff;
  margin-bottom: 12px;
  flex-wrap: nowrap;
  padding: 30px 0;
  background: linear-gradient(135deg, #3e82f7, #70a7ff);
}

.warin {
  font-size: 10px;
  color: #fff;
  position: absolute;
  left: 5px;
  bottom: 5px;
}

.summary-item {
  color: #ffffff;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  flex: 1;
}

.summary-title {
  font-size: 22px;
  font-weight: 700;
}

.summary-text {
  font-size: 12px;
  opacity: 0.9;
}

.filter-select {
  width: 120px;
}

.pie-select {
  width: 120px;
}

.stat-tabs :deep(.ant-tabs-nav) {
  width: 100%;
  display: flex;
}

.stat-tabs :deep(.ant-tabs-tab) {
  flex: 1;
  text-align: center;
  padding-left: 8px !important;
  padding-right: 8px !important;
  margin: 0;
}

.stat-tabs :deep(.ant-tabs-tab-active) {
  background: #e6f0ff;
}

.stat-tab {
  display: flex;
  flex-direction: column;

}

.stat-tab-label {
  //font-size: 12px;
}

.ai-content {
  padding: 5px 10px;
  margin: 12px 0;
  border-radius: 10px;
  background: #fff;
  display: flex;
  align-items: center;

}

.block1 {
  border-radius: 10px;
  background: #fff;
  padding: 24px;
}
</style>
